"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var SvgIcon_1 = require("./internal/SvgIcon");

exports.Trash = function (props) {
  return react_1.default.createElement(SvgIcon_1.SvgIcon, tslib_1.__assign({}, props), react_1.default.createElement("svg", {
    viewBox: "0 0 16 16"
  }, react_1.default.createElement("path", {
    fillRule: "evenodd",
    d: "M9.99997 10.9963V5.99918H8.99509V10.9963H9.99997ZM6.99901 5.99918V10.9963H7.99705V5.99918H6.99901ZM5.99413 5.99918H4.99609V10.9963H5.99413V5.99918ZM8.99509 3.99625V2.99821H5.99413V3.99625H8.99509ZM11.9961 5.99918H10.998V12.0011C10.998 12.3019 10.9069 12.5435 10.7246 12.7257C10.5423 12.908 10.3008 12.9992 9.99997 12.9992H4.99609C4.73632 12.9992 4.5039 12.9058 4.29882 12.7189C4.0983 12.5321 3.99804 12.2928 3.99804 12.0011V5.99918H3V5.00114C3 4.71858 3.10026 4.48161 3.30078 4.2902C3.5013 4.09879 3.73372 4.00081 3.99804 3.99625H4.99609V2.99821C5.00064 2.7111 5.10318 2.47184 5.3037 2.28043C5.50422 2.08903 5.73436 1.9956 5.99413 2.00016H8.99509C9.29588 2.00016 9.53741 2.0913 9.7197 2.2736C9.90199 2.45589 9.99542 2.69742 9.99997 2.99821V3.99625H10.998C11.2988 4.00081 11.5403 4.09423 11.7226 4.27653C11.9049 4.45882 11.9961 4.70035 11.9961 5.00114V5.99918Z",
    clipRule: "evenodd"
  })));
};